import { defaultSchema, Options as SanitizeSchema } from 'rehype-sanitize';

export const allowedStyleProperties = [
    'color',
    'background-color',
    'text-align',
    'text-decoration',
    'font-size',
    'font-weight',
    'font-style',
    'vertical-align',
    'list-style-type',
    'display',
    'width',
    'max-width',
    'height',
    'margin',
    'margin-top',
    'margin-right',
    'margin-bottom',
    'margin-left',
    'padding',
    'padding-top',
    'padding-right',
    'padding-bottom',
    'padding-left',
];

export const markdownSanitizeSchema: SanitizeSchema = {
    ...defaultSchema,
    strip: ['script', 'style'],
    tagNames: [
        ...(defaultSchema.tagNames || []),
        'u',
        'colgroup',
        'col',
        'main',
        'article',
        'aside',
        'header',
        'footer',
    ],
    attributes: {
        ...defaultSchema.attributes,
        '*': [...(defaultSchema.attributes?.['*'] || []), 'className', 'style'],
    },
    protocols: {
        ...defaultSchema.protocols,
        href: [...(defaultSchema.protocols?.href || []), 'tel'],
    },
};

export const htmlSanitizeConfig = {
    ADD_TAGS: ['placeholder'],
    FORBID_TAGS: ['style', 'form', 'input', 'textarea', 'select', 'button'],
};
